<template lang="pug">
.info-tooltip
  span.icon(
    v-if="mobile"
    v-tooltip.focus="message"
    tabindex="0"
  )
    i.pi(:class="icon ? icon : TooltipIcons.question")
  span.icon(
    v-else-if="direction"
    v-tooltip:[pos]="message"
  ) 
    i.pi(:class="icon ? icon : TooltipIcons.question")
  span.icon(
    v-else
    v-tooltip="message"
  ) 
    i.pi(:class="icon ? icon : TooltipIcons.question")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { TooltipPosition, TooltipIcons } from "@/types";

export default defineComponent({
  name: "InfoTooltip",
  props: {
    message: {
      type: String,
      default: "",
      required: true,
    },
    direction: {
      type: String,
      default: undefined,
      required: false,
    },
    icon: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  setup(props) {
    const mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    const pos = { position: props.direction };
    return {
      mobile,
      TooltipIcons,
      TooltipPosition,
      pos,
    };
  },
});
</script>
<style lang="scss">
.info-tooltip {
  display: inline-block;
  padding: 0.2rem;
  margin: 0 0.25rem;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pi {
    font-size: 0.9rem;
  }
}
</style>
